import { render, staticRenderFns } from "./cartList.vue?vue&type=template&id=473acd8c&scoped=true&"
import script from "./cartList.vue?vue&type=script&lang=js&"
export * from "./cartList.vue?vue&type=script&lang=js&"
import style0 from "./cartList.vue?vue&type=style&index=0&id=473acd8c&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473acd8c",
  null
  
)

export default component.exports